<template>
  <b-modal
    id="create-order-modal-generally"
    ref="modal"
    scrollable
    header-class="headerModal"
    centered
    size="xl"
    :title="$t('CreateOrderGenerally')"
    title-class="red"
    modal-class="dd"
    hide-footer
    no-close-on-backdrop
    @hide="onCancel"
  >
    <ClientSearch
      @sentClientData="sentClientDatas"
    />
    <section style="border:1px solid lightgrey;padding:10px;margin-top:10px;border-radius:12px;">
      <button
        type="button"
        variant="none"
        class="buttonSubmit"
        style="width: 240px; height: 40px;"
        @click="addHouse"
      >
        {{ $t('AddHouse') }}
      </button>
      <p
        v-if="articleList.length == 0 && createHouseItemRequestDtos.length == 0 && isButtonSubmited"
        style="color: red;padding-top: 5px;
                  margin-bottom: 0px;"
      >
        {{ $t('Please_Select_house') }}
      </p>
      <NewOrdersTree
        v-if="createHouseItemRequestDtos.length > 0"
        :create-house-item-request-dtos="createHouseItemRequestDtos"
        :is-button-submited="isButtonSubmited"
      />
    </section>
    <section style="border:1px solid lightgrey;padding:10px;margin-top:10px;border-radius:12px;">
      <p
        v-if="articleList.length == 0 && createHouseItemRequestDtos.length == 0 && isButtonSubmited"
        style="color:red;font-weight: 600;margin-top: 10px;margin-bottom: 5px"
      >
        {{ $t('NoArticlesFound') }}
      </p>
      <ArticleSell
        :article-list="articleList"
        :filiale="filiale"
        :button-submited="isButtonSubmited"
      />
    </section>
    <section
      class="custom-modal__wrapper order-cost"
      style="margin-bottom:10px;margin-top:10px;flex-direction:column;"
    >
      <div style="display:flex;margin-bottom: 10px;gap:10px;">
        <b-form-group :label="$t('TotalCostOfMaterial')">
          <b-form-input
            v-model="totalMaterialCost"
            disabled
            type="number"
          />
        </b-form-group>
        <b-form-group :label="$t('TotalFromArticles')">
          <b-form-input
            v-model="totalCost"
            disabled
            type="number"
          />
        </b-form-group>
        <b-form-group :label="$t('TotalPrice')">
          <b-form-input
            v-model="totalCostOfAllInput"
            disabled
            type="number"
          />
        </b-form-group>
      </div>
      <div>
        <div>
          <div style="display:flex;gap:4px;align-items:center;margin-bottom:5px;">
            <div style="border:1px solid lightgrey;border-radius:12px;">
              <b-icon
                icon="info"
              />
            </div>
            <span style="color: #262E6C; font-weight: 500;">
              {{ $t('IfUSelect') }}
            </span>
          </div>
          <div style="display:flex;margin-bottom:10px;">
            <b-form-group
              style="width:20%"
              :label="$t('Transport')"
            >
              <b-form-checkbox v-model="transport" />
            </b-form-group>
            <b-form-group
              style="width:20%"
              :label="$t('Montage')"
            >
              <b-form-checkbox v-model="montage" />
            </b-form-group>
          </div>
          <div style="display:flex;gap: 15px; margin-bottom: 1rem;">
            <div v-if="montage">
              <label>{{ $t('MontageStart') }}</label>
              <div style="display: flex;flex-direction: column;">
                <date-picker
                  v-model="montageStart"
                  type="datetime"
                  :placeholder="$t('SelectD')"
                  format="YYYY-MM-DD HH:mm"
                  :default-value="defaultTime"
                />
                <p
                  v-if="montageStart == null && montage && isButtonSubmited"
                  style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                >
                  {{ $t('SelectD') }}
                </p>
              </div>
            </div>
            <div
              v-if="montage"
              style="display: flex;gap:10px;"
            >
              <div class="number-steps">
                <label class="number-steps__label">{{ $t('DurationHour') }}</label>
                <div class="number-steps__input">
                  <b-form-input
                    v-model.number="durationTimeHour"
                    type="number"
                    :placeholder="$t('Hour')"
                  />
                  <div class="number-steps__buttons">
                    <b-icon-plus-circle
                      class="number-steps__button--increase"
                      @click="addHour"
                    />
                    <b-icon-dash-circle
                      class="number-steps__button--decrease"
                      @click="substractHour"
                    />
                  </div>
                </div>
              </div>
              <div class="number-steps">
                <label class="number-steps__label">{{ $t('DurationMinutes') }}</label>
                <div class="number-steps__input">
                  <b-form-input
                    v-model.number="durationTimeMinutes"
                    type="number"
                    :placeholder="$t('Minutes')"
                  />
                  <div class="number-steps__buttons">
                    <b-icon-plus-circle
                      class="number-steps__button--increase"
                      @click="addMinutes"
                    />
                    <b-icon-dash-circle
                      class="number-steps__button--decrease"
                      @click="substractMinutes"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="montage">
              <label>{{ $t('MontageEnd') }}</label>
              <div style="display: flex;flex-direction: column;">
                <date-picker
                  v-model="montageEnd"
                  type="datetime"
                  :placeholder="$t('SelectD')"
                  format="YYYY-MM-DD HH:mm"
                  disabled
                />
                <p
                  v-if="montageEnd == null && montage && isButtonSubmited"
                  style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                >
                  {{ $t('SelectD') }}
                </p>
              </div>
            </div>
            <div v-if="!montage">
              <label>{{ $t('PickupDate') }}</label>
              <div style="display: flex;flex-direction: column;">
                <date-picker
                  v-model="pickUpDate "
                  type="datetime"
                  :placeholder="$t('SelectD')"
                  format="YYYY-MM-DD HH:mm"
                  :default-value="defaultTime"
                />
                <p
                  v-if="pickUpDate == null && isButtonSubmited && !montage"
                  style="color: red;padding-top: 5px;
                      margin-bottom: 0px;"
                >
                  {{ $t('SelectD') }}
                </p>
              </div>
            </div>
          </div>
          <div style="display:flex;gap:10px;margin-bottom: 1rem;">
            <div>
              <b-form-group
                :label="$t('SellDate')"
              >
                <date-picker
                  v-model="sellDate"
                  type="date"
                  disabled
                  format="YYYY-MM-DD"
                  value-type="format"
                  :placeholder="$t('SelectD')"
                />
              </b-form-group>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 1rem;">
          <div>
            <div class="newTable">
              <!-- <div class="display-prices">
                <b-form-group
                  :label="$t('PriceNoVat')"
                >
                  <b-form-input
                    v-model.number="priceWithoutVAT"
                    type="number"
                    :placeholder="$t('Value')"
                    @input="calculateFromPriceWithoutVAT(priceWithoutVAT)"
                  />
                </b-form-group>
                <b-form-select
                  v-model="currency"
                  dropup
                  required
                  :options="currencies"
                  aria-placeholder="Select order type"
                  aria-describedby="input-1-live-feedback"
                />
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('Vat')"
                >
                  <b-form-select
                    v-model="selectedVAT"
                    dropup
                    required
                    :options="vatOptions"
                    @change="calculateFromSelectedVAT(selectedVAT)"
                  />
                </b-form-group>
              </div> -->
              <div class="display-prices">
                <b-form-group :label="$t('PriceWithVat')">
                  <b-form-input
                    v-model.number="totalCostOfAll"
                    type="number"
                    disabled
                    :placeholder="$t('Value')"
                    @input="calculateFromtotalCostOfAll(totalCostOfAll)"
                  />
                </b-form-group>

                <b-form-select
                  v-model="currency"
                  dropup
                  required
                  :options="currencies"
                />
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('Discount')"
                >
                  <b-input
                    v-model.number="discount"
                    type="number"
                    default="0"
                  />
                  <!-- :disabled="totalCostOfAll == 0 || totalCostOfAll == '' || getLoggedInUser.role !== 'CEO' && getLoggedInUser.role !== 'Manager'" -->
                </b-form-group>

                <b-form-select
                  v-model="discountType"
                >
                  <option value="$">
                    $
                  </option>
                  <option value="€">
                    €
                  </option>
                  <option value="CHF">
                    CHF
                  </option>
                  <option value="%">
                    %
                  </option>
                </b-form-select>
              </div>
              <div class="display-prices">
                <b-form-group
                  :label="$t('DiscountedPrice')"
                >
                  <b-input
                    v-model.number="discountedPrice"
                    disabled
                    type="number"
                  />
                </b-form-group>
                <b-form-select
                  v-model="currency"
                  dropup
                  required
                  :options="currencies"
                  aria-placeholder="Select order type"
                />
              </div>
            </div>
            <div class="newTable">
              <div
                class="display-prices"
              >
                <b-form-group
                  :label="$t('PaidPrice')"
                >
                  <b-input
                    v-model.number="paidPrice"
                    type="number"
                    style="width:220px;"
                  />
                </b-form-group>
                <b-form-select
                  v-model="currency"
                  dropup
                  required
                  :options="currencies"
                  aria-placeholder="Select order type"
                  aria-describedby="input-1-live-feedback"
                />
              </div>
              <div
                class="display-prices"
                style="width:15%"
              >
                <b-form-group
                  :label="$t('Account')"
                  style="width:100%"
                >
                  <vue-select
                    v-model="accountId"
                    :options="getAccountDetails"
                    :reduce="(e) => e.accountId"
                    label="name"
                    :placeholder="$t('Select')"
                    style="width:100%"
                  />
                  <p
                    v-if="paidPrice > 0 && accountId == null"
                    style="color:red;"
                  >
                    {{ $t('SelectAccount') }}
                  </p>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="price-container">
        <h5 class="price-text">
          {{ $t("TotalP") }}:
          <p style="display:flex;justify-content:space-between;">
            {{ discountedPrice || 0 }}
            <span>€</span>
          </p>
        </h5>
        <h5 class="price-text">
          {{ $t("TotalPD") }}:
          <p style="display:flex;justify-content:space-between;">
            {{ paidPrice || 0 }}
            <span>€</span>
          </p>

        </h5>
        <h5 class="price-text">
          {{ $t("BillR") }}:
          <p style="display:flex;justify-content:space-between;">
            {{ (remainingPriceTotal).toFixed(2) || 0 }}
            <span>€</span>
          </p>
        </h5>
        <h5
          v-if="plusTotal > 0"
          class="price-text"
        >
          {{ $t("Bonus") }}, {{ $t('TotalPD') }} > {{ $t('TotalP') }}
          <p style="display:flex;justify-content:space-between;">
            {{ (plusTotal).toFixed(2) || 0 }}
            <span>€</span>
          </p>
        </h5>
      </div>
    </section>
    <GenerateInvoiceCoupon
      v-if="invoiceForCoupon"
      ref="couponGenerator"
      :invoice="invoiceForCoupon"
    />
    <div
      style="display: flex; flex-direction:column; margin: 20px 0; padding:10px;border: 1px solid lightgray; border-radius: 10px;"
    >
      <div style="display: flex; gap: 10px; width:100%">
        <div style="display:flex;flex-direction:column;width:20%">
          <StoresDropdown
            :filiale="filiale"
            style="width: 100%;"
            :hide-label="false"
            @updateFiliale="updateFiliale"
          />
          <p
            v-if="(filiale.storeId == null || filiale.storeId == '00000000-0000-0000-0000-000000000000') && isButtonSubmited"
            style="color:red;"
          >
            {{ $t('SelectStore') }}
          </p>
        </div>
        <b-form-group
          v-if="getLoggedInUser.role !== 'SalesPerson' && getLoggedInUser.role !== 'OnlineSales' "
          :label="$t('SelectSalesPerson')"
          style="width: 25%;"
        >
          <vue-select
            v-model="roleId"
            :options="getRegularEmployeesById"
            required
            label="name"
            :reduce="(account) => account.userId"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
            style="width: 100%;"
          />
        </b-form-group>
        <b-form-group
          :label="$t('GeneratePDFas')"
          style="width: 25%;"
        >
          <vue-select
            v-model="pdfText"
            :options="[
              { label: $t('DontGenerate'), value: 'DontGenerate' },
              { label: $t('Avans'), value: 'Avans' },
              { label: $t('Invoice'), value: 'Invoice' },
              { label: $t('Offer'), value: 'Offer' }
            ]"
            :reduce="option => option.value"
            :clearable="false"
            label="label"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
            style="width: 100%;"
          />
          <div class="d-none">
            <XharraIconBase64 ref="xharraIconBase64" />
            <IconLogoBase64 ref="iconLogoBase64" />
            <QrCodeLogoBase64 ref="qrCodeLogoBase64" />
            <FacebookLogoBase64 ref="facebookLogoBase64" />
            <InstaLogoBase64 ref="instaLogoBase64" />
            <MailLogoBase64 ref="mailLogoBase64" />
          </div>
        </b-form-group>
      </div>
      <b-form-group
        style="width:100%"
        :label="$t('InvoiceRemark')"
        class="mt-4"
      >
        <b-form-textarea
          v-model="invoiceRemark"
          :placeholder="$t('Type')"
          style="width:100%"
        />
      </b-form-group>
    </div>
    <section style="display:flex;flex-direction:column;border:1px solid lightgrey;padding:10px;margin-top:10px;border-radius:12px;">
      <div style="display: flex; gap: 12px; padding: 3px">
        <AddFile
          ref="addFile1"
          :folder="'OrderPhotos'"
          :label-text="$t('UploadSketch')"
          :file-data-type="'Scetch'"
          :file-name="createFileDataDto"
          :file-format="'firstFormat'"
        />
        <AddFile
          ref="addFile2"
          :folder="'OrderPhotos'"
          :label-text="$t('UploadContract')"
          :file-data-type="'Contract'"
          :file-name="createFileDataDto"
          :file-format="'firstFormat'"
        />
        <AddFile
          ref="addFile3"
          :folder="'OrderPhotos'"
          :label-text="$t('OtherDocuments')"
          :file-data-type="'OtherDocument'"
          :file-name="createFileDataDto"
          :file-format="'firstFormat'"
        />
      </div>
      <div>
        <b-form-group
          :label="$t('Notes')"
          style="width: 100%;"
        >
          <b-form-textarea
            id="textarea"
            v-model="description"
            :placeholder="$t('RequestedChangesByCustomer')"
            style="width: 100%;"
          />
          <b-form-invalid-feedback id="input-1-live-feedback">
            {{ $t('RequiredFields') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
    </section>
    <div class="buttonsEverywhere">
      <button
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        @click="onSubmit"
      >
        <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import XharraIconBase64 from '@/components/PdfDocument/xharraIconBase64.vue';
import IconLogoBase64 from '@/components/PdfDocument/IconLogoBase64.vue';
import QrCodeLogoBase64 from '@/components/PdfDocument/QrCodeLogoBase64.vue';
import FacebookLogoBase64 from '@/components/PdfDocument/FacebookLogoBase64.vue';
import InstaLogoBase64 from '@/components/PdfDocument/InstaLogoBase64.vue';
import MailLogoBase64 from '@/components/PdfDocument/MailLogoBase64.vue';
import ClientSearch from '../components/productsInStock/modals/ClientSearch.vue'
import ArticleSell from '../components/productsInStock/modals/ArticleSell.vue';
import NewOrdersTree from '../components/orders/NewOrdersTree.vue';
import AddFile from './AddFile.vue'
import StoresDropdown from '../components/StoresDropdown.vue';
import GenerateInvoiceCoupon from '../components/GenerateInvoiceCoupon.vue';
import { client } from '../domainConfig'
import 'vue2-datepicker/index.css';

export default {
  components: {
    ClientSearch,
    ArticleSell,
    NewOrdersTree,
    AddFile,
    StoresDropdown,
    DatePicker,
    XharraIconBase64,
    IconLogoBase64,
    QrCodeLogoBase64,
    FacebookLogoBase64,
    InstaLogoBase64,
    MailLogoBase64,
    GenerateInvoiceCoupon,
  },
  props: [],
  data() {
    return {
      pdfText: 'Invoice',
      defaultTime: new Date().setHours(8, 0, 0, 0),
      loading: false,
      createHouseItemRequestDtos: [],
      articleList: [],
      isButtonSubmited: false,
      clientData: null,
      clientError: false,
      filiale: { storeId: null, storeName: 'No filiale', storeGLN: null },
      totalCost: 0,
      createFileDataDto: [],
      shippings: {
        cost: null,
        accountId: null,
        currency: '€',
        notes: '',
        paidAmount: null,
      },
      description: '',
      roleId: null,
      invoiceRemark: null,
      sellDate: moment().format('YYYY-MM-DD'),
      pickUpDate: null,
      transport: true,
      montage: true,
      montageStart: null,
      montageEnd: null,
      durationTimeMinutes: 0,
      durationTimeHour: 0,
      accountId: null,
      priceWithoutVAT: 0,
      selectedVAT: 18,
      vatOptions: [
        { text: '18%', value: 18 },
        { text: '8%', value: 8 },
        { text: '0%', value: 0 },
      ],
      totalCostOfAll: 0,
      currencies: ['€', '$', 'CHF'],
      currency: '€',
      discountType: '€',
      discount: 0,
      paidPrice: 0,
      remainingPriceTotal: 0,
      plusTotal: 0,
      addressOfClient: null,
      addressOfStore: null,
      nameOfClient: null,
      emailOfClient: null,
      phoneOfClient: null,
      orderNumber: null,
      taxPrice: 0,
      totalPrice: 0,
      shipmentPrice: null,
      shipmentCode: null,
      paidAmount: null,
      remark: null,
      client: client.clientName,
      invoiceForCoupon: null,
    }
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getNewInvoiceByOrderNumber', 'getRegularEmployeesById', 'getAccountDetails']),
    totalMaterialCost() {
      let totalCost = 0;

      const calculateCost = (materialDtos) => {
        materialDtos.forEach((material) => {
          totalCost += parseFloat(material.totalPerMeter);
        });
      };

      this.createHouseItemRequestDtos.forEach((house) => {
        house.createFloorRequestDtos.forEach((floor) => {
          floor.createRoomRequestDtos.forEach((room) => {
            room.createWindowRequestDtos.forEach((window) => {
              calculateCost(window.materialVariantInStoreDtos);
              if (window.createWindowDecorativeRequestDtos) {
                window.createWindowDecorativeRequestDtos.forEach((decorativeWindow) => {
                  calculateCost(decorativeWindow.materialVariantInStoreDtos);
                });
              }
            });
          });
        });
      });

      return Math.ceil(totalCost);
    },
    discountedPrice: {
      get() {
        if (this.discountType === '$' || this.discountType === '€' || this.discountType === 'CHF') {
          return this.totalCostOfAll - this.discount;
        } if (this.discountType === '%') {
          if (this.totalCostOfAll === 0) {
            return 0; // Avoid division by zero
          }
          const percentageDiscount = (this.discount / 100) * this.totalCostOfAll;
          return (this.totalCostOfAll - percentageDiscount).toFixed(2);
        }

        // Default to 0 when no discount type is selected
        return 0;
      },
      set(value) {
        // You can add validation here if needed
        if (this.discountType === '$' || this.discountType === '€' || this.discountType === 'CHF') {
          this.discount = this.totalCostOfAll - value;
        } else if (this.discountType === '%') {
          if (this.totalCostOfAll === 0) {
            this.discount = 0; // Avoid division by zero
          } else {
            const percentageDiscount = (this.totalCostOfAll - value) / (this.totalCostOfAll * 100);
            this.discount = percentageDiscount;
          }
        }
      },
    },
    totalCostOfAllInput() {
      return (this.totalMaterialCost + this.totalCost).toFixed(2) || 0;
    },
  },
  watch: {
    articleList: {
      handler(newValue) {
        this.totalCost = newValue.reduce((total, article) => {
          return total + parseFloat(article.valueWithVAT);
        }, 0);
        this.totalCost = parseFloat(this.totalCost.toFixed(2)) || 0;
        this.totalCostOfAll = this.totalMaterialCost + this.totalCost;
        // this.calculateFromtotalCostOfAll(this.totalCostOfAll);
      },
      deep: true,
    },
    totalMaterialCost(newValue) {
      this.totalCostOfAll = newValue + this.totalCost;
    },
    montageStart(value) {
      if (value) {
        this.calculateMontageEnd();
      } else {
        this.durationTimeHour = 0;
        this.durationTimeMinutes = 0
        this.montageEnd = null
      }
    },
    paidPrice() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (this.paidPrice > this.discountedPrice) {
          this.remainingPriceTotal = 0
          this.plusTotal = -(this.discountedPrice - this.paidPrice)
        } else {
          this.remainingPriceTotal = this.discountedPrice - this.paidPrice
          this.plusTotal = 0
        }
      }, 0);
    },
    durationTimeHour(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0) {
          this.durationTimeHour = 0;
        } else if (value === '') {
          this.durationTimeHour = 0;
        } else {
          const fullHours = Math.floor(value);
          const fractionalPart = value - fullHours;

          this.durationTimeHour = fullHours;
          this.durationTimeMinutes += Math.round(fractionalPart * 60);
        }
        this.calculateMontageEnd()
      }, 0);
    },
    durationTimeMinutes(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value < 0) {
          this.durationTimeMinutes = 0
        }
        if (value == '') {
          this.durationTimeMinutes = 0;
        }
        if (value >= 60) {
          const totalHours = Math.floor(value / 60);
          this.durationTimeHour += totalHours;

          const fractionalPart = (value / 60) - totalHours;
          const remainingMinutes = Math.round(fractionalPart * 60);

          this.durationTimeMinutes = remainingMinutes;
        }
        if (value < 0 && this.durationTimeHour > 0) {
          this.durationTimeHour -= 1
          this.durationTimeMinutes = 45
        }
        this.calculateMontageEnd()
      }, 0);
    },
    montage(value) {
      if (value == true) {
        this.pickUpDate = null
      } else {
        this.montageStart = null
        this.montageEnd = null
        this.durationTimeMinutes = 0
        this.durationTimeHour = 0
        this.montageCost = 0
      }
    },
    transport(value) {
      if (value == false) {
        this.transportCost = 0
      }
    },
    // totalMaterialCost(value) {
    //   if (this.timeoutId) {
    //     clearTimeout(this.timeoutId);
    //   }
    //   this.timeoutId = setTimeout(() => {
    //     if (value == '') {
    //       this.totalMaterialCost = 0
    //     }
    //   }, 0);
    // },
  },
  methods: {
    ...mapActions(['loadRegularEmployeesId', 'resetFirstNames', 'loadInvoiceByOrderItem', 'resetClientId', 'createOrderGenerally']),
    calculateFromtotalCostOfAll(value) {
      if (this.amount > 0) {
        this.priceWithoutVAT = parseFloat((value / (1 + this.selectedVAT / 100)).toFixed(2));
        this.valueWithVAT = parseFloat((value * this.amount).toFixed(2));
      } else {
        this.priceWithoutVAT = parseFloat((value / (1 + this.selectedVAT / 100)).toFixed(2));
      }
      if (this.paidPrice > this.discountedPrice) {
        this.remainingPriceTotal = 0
        this.plusTotal = -(this.discountedPrice - this.paidPrice)
      } else {
        this.remainingPriceTotal = this.discountedPrice - this.paidPrice
        this.plusTotal = 0
      }
    },
    calculateFromSelectedVAT(value) {
      if (this.amount > 0) {
        this.totalCostOfAll = parseFloat((this.priceWithoutVAT * (1 + value / 100)).toFixed(2));
        this.valueWithVAT = parseFloat((this.totalCostOfAll * this.amount).toFixed(2));
      } else if (this.priceWithoutVAT > 0) {
        this.totalCostOfAll = parseFloat((this.priceWithoutVAT * (1 + value / 100)).toFixed(2));
      }

      if (this.totalCostOfAll > 0) {
        this.priceWithoutVAT = parseFloat((this.totalCostOfAll / (1 + value / 100)).toFixed(2));
      }
      if (this.paidPrice > this.discountedPrice) {
        this.remainingPriceTotal = 0
        this.plusTotal = -(this.discountedPrice - this.paidPrice)
      } else {
        this.remainingPriceTotal = this.discountedPrice - this.paidPrice
        this.plusTotal = 0
      }
    },
    calculateFromPriceWithoutVAT(value) {
      if (this.amount > 0) {
        this.totalCostOfAll = parseFloat((value * (1 + this.selectedVAT / 100)).toFixed(2));
        this.valueWithVAT = parseFloat((this.totalCostOfAll * this.amount).toFixed(2));
      } else {
        this.totalCostOfAll = parseFloat((value * (1 + this.selectedVAT / 100)).toFixed(2));
      }
      if (this.paidPrice > this.discountedPrice) {
        this.remainingPriceTotal = 0
        this.plusTotal = -(this.discountedPrice - this.paidPrice)
      } else {
        this.remainingPriceTotal = this.discountedPrice - this.paidPrice
        this.plusTotal = 0
      }
    },
    calculateMontageEnd() {
      if (this.montageStart && this.durationTimeHour != null && this.durationTimeMinutes != null) {
        const startDate = new Date(this.montageStart);
        startDate.setHours(startDate.getHours() + this.durationTimeHour);
        startDate.setMinutes(startDate.getMinutes() + this.durationTimeMinutes);
        startDate.setSeconds(0);
        this.montageEnd = startDate;
      }
    },
    addHour() {
      this.durationTimeHour++;
      this.calculateMontageEnd();
    },
    substractHour() {
      this.durationTimeHour--;
      this.calculateMontageEnd();
    },
    addMinutes() {
      this.durationTimeMinutes += 15
      this.calculateMontageEnd();
    },
    substractMinutes() {
      this.durationTimeMinutes -= 15
      this.calculateMontageEnd();
    },
    updateFiliale(newFiliale) {
      this.filiale = newFiliale;
      this.loadRegularEmployeesId({ storeId: newFiliale.storeId })
      this.roleId = null
    },
    sentClientDatas(value) {
      this.clientData = value.clientData
      this.clientError = value.errorClient
    },
    addHouse() {
      const houseNumber = this.createHouseItemRequestDtos.length + 1;
      this.createHouseItemRequestDtos.push({
        name: `Shtepia nr ${houseNumber}`, createFloorRequestDtos: [], editable: false,
      });
    },
    async onSubmit() {
      this.isButtonSubmited = true
      // this is for both modals
      if (this.clientError && this.isButtonSubmited) {
        return;
      }
      if (this.filiale.storeId == null || this.filiale.storeId == '00000000-0000-0000-0000-000000000000') {
        return
      }
      // this is for houses
      const hasInvalidData = this.createHouseItemRequestDtos.length === 0
  || this.createHouseItemRequestDtos.some((house) => {
    return house.createFloorRequestDtos.length === 0
      || house.createFloorRequestDtos.some((floor) => {
        return floor.createRoomRequestDtos.length === 0
          || floor.createRoomRequestDtos.some((room) => {
            return room.createWindowRequestDtos.length === 0
              || room.createWindowRequestDtos.some((window) => {
                const isInvalidWindow = window.width <= 0
                  || window.height <= 0
                  || !window.sewingType
                  || window.materialVariantInStoreDtos.length === 0
                  || window.materialVariantInStoreDtos.some((material) => {
                    return !material.name
                      || (material.quantity <= 0
                      && parseFloat(material.length) <= 0
                      && material.pricePerMeterWithDiscount <= 0);
                  });

                const isInvalidDecorative = window.createWindowDecorativeRequestDtos.length > 0
                  && window.createWindowDecorativeRequestDtos.some((decorative) => {
                    return decorative.width <= 0
                      || decorative.height <= 0
                      || !decorative.sewingType
                      || decorative.materialVariantInStoreDtos.length === 0
                      || decorative.materialVariantInStoreDtos.some((material) => {
                        return !material.name
                          || (material.quantity <= 0
                          && parseFloat(material.length) <= 0
                          && material.pricePerMeterWithDiscount <= 0);
                      });
                  });

                return isInvalidWindow || isInvalidDecorative;
              });
          });
      });
  });
      if (hasInvalidData && this.createHouseItemRequestDtos.length > 0) {
        return;
      }
      if (this.montage && this.montageStart == null && this.montageEnd == null) {
        return;
      }
      if (this.paidPrice > 0 && this.accountId == null) {
        return
      }
      if (!this.montage && this.pickUpDate == null) {
        return;
      }
      const houseItems = this.createHouseItemRequestDtos.map((houseItem) => {
        return {
          ...houseItem,
          createFloorRequestDtos: houseItem.createFloorRequestDtos.map((floorItem) => {
            return {
              ...floorItem,
              createRoomRequestDtos: floorItem.createRoomRequestDtos.map((roomItem) => {
                return {
                  ...roomItem,
                  createWindowRequestDtos: roomItem.createWindowRequestDtos.map(({ hingType, ...windowItem }) => {
                    if (windowItem.sewingType && windowItem.sewingType.value) {
                      windowItem.sewingType = windowItem.sewingType.value;
                    }
                    return {
                      ...windowItem,
                      materialVariantInStoreDtos: windowItem.materialVariantInStoreDtos.filter((variant) => { return variant.name !== null })
                        .map(({ length, ...variant }) => {
                          return {
                            ...variant,
                            quantity: Math.max(variant.quantity, parseFloat(length) || 0) || 0,
                          }
                        }),
                      createWindowDecorativeRequestDtos: windowItem.createWindowDecorativeRequestDtos.map((windowVariant) => {
                        if (windowVariant.sewingType && windowVariant.sewingType.value) {
                          windowVariant.sewingType = windowVariant.sewingType.value;
                        }
                        return {
                          ...windowVariant,
                          name: `${windowItem.name} - ${windowVariant.hingType}`,
                          materialVariantInStoreDtos: windowVariant.materialVariantInStoreDtos.filter((variant) => { return variant.name !== null })
                            .map(({ length, ...variant }) => {
                              return {
                                ...variant,
                                quantity: Math.max(variant.quantity, parseFloat(length) || 0) || 0,
                              }
                            }),
                        };
                      }),
                    };
                  }),
                }
              }),
            }
          }),
        }
      });
      await this.$refs.addFile1.uploadFile();
      await this.$refs.addFile2.uploadFile();
      await this.$refs.addFile3.uploadFile();
      const groupedFiles = this.createFileDataDto.reduce((grouped, item) => {
        const fileType = item.fileDataType;

        if (!grouped[fileType]) {
          grouped[fileType] = { fileDataType: fileType, fileUrl: [] };
        }

        grouped[fileType].fileUrl.push(item.fileUrl);

        return grouped;
      }, {});
      const groupedFileArray = Object.values(groupedFiles).map((group) => {
        return {
          fileDataType: group.fileDataType,
          fileUrl: group.fileUrl.flat(),
        };
      });
      // this is for articles
      if (this.articleList.length == 0 && this.createHouseItemRequestDtos.length == 0 && this.isButtonSubmited) {
        return;
      }
      const toady = moment().format('YYYY-MM-DD')
      const articles = this.articleList.map((item) => {
        return {
          quantity: item.quantity,
          quantityMultiplier: item.measurementType == 'Meter' ? item.quantityMeter : 1,
          price: item.priceWithVAT || 0,
          priceWithDiscount: item.discountedPrice || 0,
          discount: item.discount || 0,
          productInStockId: item.productInStockId,
          productId: item.inventoryProductId || null,
          scheduledPickupDate: item.pickedUpDate !== toady ? item.pickedUpDate : null,
          pickedUpDate: item.pickedUpDate == toady ? item.pickedUpDate : null,
          orderedArticleNumber: item.orderedArticleNumber,
          orderedProductId: item.orderedProductId || null,
          measurementType: item.measurementType,
        }
      })
      let taxRate = 18;

      if (this.articleList[0]?.selectedVAT === 0) {
        taxRate = 0;
      } else if (this.articleList[0]?.selectedVAT === 8) {
        taxRate = 8;
      }
      // the object for both of them
      const object = {
        orderItems: articles,
        createHouseItemRequestDtos: houseItems,
        ordererDto: this.clientData.ordererDto,
        billingAddressDto: this.clientData.billingAddressDto,
        shippingAddressDto: this.clientData.shippingAddressDto,
        clientId: this.clientData.clientId,
        orderType: this.clientData.orderType,
        pickUpInStore: this.clientData.pickUpInStore,
        createFileDataRequestDtos: groupedFileArray,
        shippingCostRequestDto: this.shippings,
        pickUpLocationId: this.filiale.storeId,
        storeId: this.filiale.storeId,
        montageStart: this.montageStart,
        montageEnd: this.montageEnd,
        description: this.description,
        salesUserId: this.roleId,
        invoiceRemark: this.invoiceRemark,
        taxRate,
        paidNotes: null,
        notes: null,
        sellDate: this.sellDate,
        pickUpDate: this.pickUpDate,
        accountId: this.accountId,
        discount: this.discount || 0,
        price: this.totalCostOfAll || 0,
        paidAmount: this.paidPrice || 0,
      }
      try {
        this.loading = true
        // --- Calculate final discount value here ---
        const discountValue = (this.totalCostOfAll - parseFloat(this.discountedPrice || 0)).toFixed(2);
        object.discount = parseFloat(discountValue);

        await this.createOrderGenerally({
          object,
          successCallback: (response) => {
            if (this.pdfText !== 'DontGenerate') {
              this.downloadInvoiceNew(response);
            } else {
              this.$emit('closeSidebar')
              this.selectedVAT = 18;
              this.loading = false
              this.resetForm();
            }
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    downloadInvoiceNew(value, value1) {
      this.dateOfCreated = value1
      this.orderNumberClient = value
      this.loadInvoiceByOrderItem({
        orderId: value,
      })
        .then(() => {
          const invoice = this.getNewInvoiceByOrderNumber;
          this.invoiceForCoupon = invoice;
          // TXT generation is now handled by the child watcher
          const tableContent = this.generateInvoiceTableContentNew(invoice);

          const xharraIcon = this.$refs.xharraIconBase64.getBase64Image();
          const iconLogo = this.$refs.iconLogoBase64.getBase64Image()
          const qrCodeLogo = this.$refs.qrCodeLogoBase64.getBase64Image()
          const facebookLogo = this.$refs.facebookLogoBase64.getBase64Image()
          const instaLogo = this.$refs.instaLogoBase64.getBase64Image()
          const mailLogo = this.$refs.mailLogoBase64.getBase64Image()

          const pdfDocument = this.generateInvoiceNew(tableContent, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800);
          // --- Trigger coupon TXT download here, just like PDF preview ---
          if (this.$refs.couponGenerator) {
            this.$refs.couponGenerator.generateCouponTxt();
          }
          this.$emit('closeSidebar')
          this.selectedVAT = 18;
          this.loading = false
          this.resetForm();
          // Save the PDF
          const pdfBlob = pdfDocument.output('blob');
          const blobUrl = URL.createObjectURL(pdfBlob);

          // Save the Blob URL to localStorage or sessionStorage
          sessionStorage.setItem('pdfBlobUrl', blobUrl);
          sessionStorage.setItem('pathName', this.$route.path);

          // Navigate to the PDF preview page using Vue Router
          this.$router.push({ name: 'Pdf Preview' });
        })
        .catch((error) => {
          this.$emit('closeSidebar')
          this.selectedVAT = 18;
          this.loading = false
          this.resetForm();
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    previewPdf(blobUrl) {
      // Assuming you have an iframe in your HTML to show the PDF preview
      const iframe = document.getElementById('pdf-preview');
      if (iframe) {
        iframe.src = blobUrl;
      } else {
        console.error('PDF preview iframe not found.');
      }
    },
    generateInvoiceTableContentNew(invoice) {
      // Define table headers
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('Barcode')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Unit1')}`,
        `${this.$t('Quantity')}`,
        `${this.$t('Price')}`,
        `${this.$t('Discount')}`,
        `${this.$t('PriceWithDiscount')}`,
        `${this.$t('TotalPriceInvoice')}`,
      ];

      // Extract header details
      const {
        headerDto, itemsDto, clientDetailsResponseDto,
      } = invoice;

      // Extract client details
      this.nameOfClient = clientDetailsResponseDto.clientName;
      this.emailOfClient = clientDetailsResponseDto.email;
      this.phoneOfClient = clientDetailsResponseDto.telephoneNumber;
      this.addressOfClient = {
        street: clientDetailsResponseDto.addressDto?.street || this.$t('NotFound'),
        city: clientDetailsResponseDto.addressDto?.city || this.$t('NotFound'),
        postalCode: clientDetailsResponseDto.addressDto?.postalCode || this.$t('NotFound'),
        country: clientDetailsResponseDto.addressDto?.country || this.$t('NotFound'),
      };
      this.addressOfStore = {
        street: headerDto.storeDetail?.street || this.$t('NotFound'),
        city: headerDto.storeDetail?.city || this.$t('NotFound'),
        postalCode: headerDto.storeDetail?.postalCode || this.$t('NotFound'),
        country: headerDto.storeDetail?.country || this.$t('NotFound'),
        storeName: headerDto.storeDetail?.storeName || this.$t('NotFound'),
      }

      // Extract header information
      this.orderNumber = headerDto.orderNumber;
      this.sellDate = headerDto.sellDate;
      this.totalPrice = ((headerDto.totalPrice || 0) - (headerDto.discount || 0)).toFixed(2);
      this.discount = headerDto.discount;
      this.selectedVAT = headerDto.taxRate;
      this.shipmentPrice = headerDto.discount?.toFixed(2) ?? '0.00';
      this.shipmentCode = headerDto.shipmentCode;
      this.paidAmount = headerDto.paidAmount?.toFixed(2);
      this.remark = headerDto?.invoiceRemark ? headerDto?.invoiceRemark : '';
      this.taxPrice = parseFloat((this.totalPrice - (this.totalPrice / (1 + this.selectedVAT / 100))).toFixed(2))

      // Map items to table body
      const body = itemsDto.map((item, index) => {
        return [
          index + 1,
          item.barcode || this.$t('NoBarcode'),
          item.articleNumber,
          item.type,
          item.quantity,
          item.price?.toFixed(2),
          item.price?.toFixed(2) - item.priceWithDiscount?.toFixed(2),
          item.priceWithDiscount?.toFixed(2),
          (item.quantity * item.priceWithDiscount).toFixed(2),
        ];
      });

      return {
        headers,
        body,
      };
    },
    generateInvoiceNew(tableContent, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instagramLogo, mailLogo, customWidth) {
      const { headers, body } = tableContent;

      // Split the body into chunks of 5 rows each
      const rowsPerPageFirst = 9;
      const rowsPerPageOther = 16;

      const getTotalPages = (bodys) => {
        const totalRows = bodys.length;
        // First page shows 10 rows
        const remainingRows = totalRows - rowsPerPageFirst;
        // For the remaining rows, we will calculate how many full pages of 15 rows fit
        const otherPages = remainingRows > 0 ? Math.ceil(remainingRows / rowsPerPageOther) : 0;
        // Total pages is the first page plus any additional pages needed for the remaining rows
        return 1 + otherPages;
      };

      const totalPages = getTotalPages(body);

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const staticContent = () => {
        const title = this.$t(this.pdfText);
        const titleY = 90;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 50;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        // Location and Phone details
        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = doc.internal.pageSize.getHeight() - 90; // Start just above the footer
        const locationSpacing = 132; // Space between each location block

        const startXPosition = 40; // Starting position for the first location
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132; // End X position based on number of locations

        // Loop through the locations array and display each one
        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing; // Adjust X position for each location
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0); // Black color

          // Add the location icon
          const iconXPosition = xPosition - 25; // Position the icon just before the location name
          const iconYPosition = locationsY - 10; // Position the icon just above the location name
          doc.addImage(iconLogo, 'PNG', iconXPosition, iconYPosition, 28, 29); // Icon size 10x10 (adjust as needed)

          // Display the location name
          doc.text(location.name, xPosition, locationsY);

          doc.text(location.name2, xPosition, locationsY + 15);

          // Display the phone number below the location name
          doc.text(location.phone, xPosition, locationsY + 30); // Position phone number below the location name
        });

        // Add a line under the locations block, spanning the width of the locations
        doc.setDrawColor(0, 0, 0); // Black color for the line
        const lineY = locationsY + 40; // Position the line just below the last location's phone number
        doc.line(startXPosition, lineY, endXPosition, lineY); // Draw a line across the width of the locations

        // Show the three items in a row below the line
        const itemsXStart = 40; // Starting position for the row of items
        const itemsY = lineY + 3; // Y-position for the items row

        const items = [
          { icon: facebookLogo, text: 'NOTAbrillantOfficial' },
          { icon: instagramLogo, text: 'nota.brillant' },
          { icon: mailLogo, text: 'info@notabrillantofficial.com' },
        ];

        // Space between each item in the row
        const itemSpacing = 150; // Adjust this for the space between icons and text

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing; // Calculate horizontal position for each item

          // Add the icon and text next to each other
          doc.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20); // Icon position and size
          doc.setFontSize(12);
          doc.text(item.text, xPosition + 25, itemsY + 15); // Position text next to the icon (adjust the X offset if needed)
        });

        // QR code section
        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = doc.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2; // Center the text above the QR code
        const qrCodeTextY = doc.internal.pageSize.getHeight() - 60; // Adjust the Y position to place text above the QR code
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(qrCodeText, qrCodeTextX, qrCodeTextY);

        // Add the QR code image
        doc.addImage(qrCodeLogo, 'PNG', 680, doc.internal.pageSize.getHeight() - 50, 45, 45);

        // Footer section
        const footerText = 'Powered by DigIT';
        const footerTextWidth = doc.getTextWidth(footerText);
        const centerX = (doc.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;

        doc.setFontSize(10);
        doc.setTextColor(160, 160, 160);
        doc.text(footerText, centerX, footerY);
      };





      // Function to render the table for a specific page
      const renderTable = (pageIndex) => {
        const rowsPerPage = pageIndex === 0 ? rowsPerPageFirst : rowsPerPageOther;

        // Calculate the starting and ending rows for this page
        const startRow = pageIndex === 0 ? 0 : rowsPerPageFirst + (pageIndex - 1) * rowsPerPage;
        const endRow = startRow + rowsPerPage;

        // Ensure we do not go out of bounds by adjusting the end row if necessary
        const tableBody = body.slice(startRow, Math.min(endRow, body.length));

        const tableOptions = {
          startY: pageIndex === 0 ? 430 : 250, // First page starts lower, subsequent pages start from the top
          head: [headers],
          body: tableBody,
          headStyles: {
            fillColor: [249, 249, 249],
            textColor: [96, 96, 96],
            lineColor: [181, 181, 181],
            lineWidth: 0.1,
            halign: 'left',
          },
          bodyStyles: {
            textColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          pageBreak: 'auto',
          columnStyles: {
            0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
            1: { columnWidth: doc.internal.pageSize.getWidth() / 6, halign: 'left', fillColor: [255, 255, 255] },
            2: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
            3: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            4: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            5: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            6: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            7: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
            8: { columnWidth: doc.internal.pageSize.getWidth() / 13, halign: 'left', fillColor: [255, 255, 255] },
          },
          afterPageContent: staticContent,
        };

        doc.autoTable(tableOptions);
      };

      // Only render the static content (title, icon, etc.) on the first page
      const renderStaticContent = () => {
        const from = this.$t('From');
        const fromY = 160;
        const fromX = 40;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(from, fromX, fromY, { align: 'left' });

        const lineStartX = fromX;
        const lineEndX = 300; // Adjust to your desired width
        const lineY = fromY + 5; // Add some spacing below "From"
        doc.setDrawColor(160, 160, 160); // Set line color to gray
        doc.setLineWidth(0.3); // Adjust thickness of the line
        doc.line(lineStartX, lineY, lineEndX, lineY);

        const author4X = fromX;
        const author4Y = 180;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(`${this.client}`, author4X, author4Y);

        let phone;
        let emails
        let url
        if (this.client === 'NotaBrillant') {
          phone = '+383 44 117 090';
          emails = 'kujdesi@nota-brillant.com'
          url = 'nota-brillant.com'
        } else {
          phone = '+383 49 999 433';
          emails = 'contacts@digitbusiness.ch'
          url = 'digitbusiness.ch'
        }

        const phoneX = fromX;
        const phoneY = 200;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(phone, phoneX, phoneY);

        const emailX = fromX;
        const emailY = 220;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(emails, emailX, emailY);

        const addressX = fromX;
        const addressY = 240;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(
          `${this.addressOfStore?.city}, ${this.addressOfStore?.street}, ${this.$t('Filiale')}:${this.addressOfStore?.storeName}`,
          addressX,
          addressY,
        );

        const urlX = fromX;
        const urlY = 260;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(url, urlX, urlY);

        const date = this.$t('PrintingDate');
        const dateY = 180;
        const dateX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(date, dateX, dateY, { align: 'left' });

        const todayDate = `${this.$t(moment().format('dddd'))}, ${moment().format('DD-MM-YYYY')}`;
        const todayDateY = dateY + 17;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(todayDate, dateX, todayDateY, { align: 'left' });

        const order = this.$t('OrderNumber');
        const orderY = 255;
        const orderX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(order, orderX, orderY, { align: 'left' });

        const author14X = 400;
        const author14Y = 275;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.orderNumber}`, author14X, author14Y, { align: 'left' });

        const sell = this.$t('SellDate');
        const sellY = 215;
        const sellX = 400;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(sell, sellX, sellY, { align: 'left' });

        const author14XSell = 400;
        const author14YSell = 235;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.$t(moment(this.sellDate).format('dddd'))}, ${moment(this.sellDate).format('DD-MM-YYYY')}`, author14XSell, author14YSell, { align: 'left' });

        const to = this.$t('To');
        const toY = 290;
        const toX = 40;
        doc.setFontSize(12);
        doc.setTextColor(96, 96, 96);
        doc.text(to, toX, toY, { align: 'left' });

        const toLineStartX = toX;
        const toLineEndX = 300; // Adjust to your desired width
        const toLineY = toY + 5; // Add some spacing below "To"
        doc.setDrawColor(160, 160, 160); // Set line color to gray
        doc.setLineWidth(0.3); // Adjust thickness of the line
        doc.line(toLineStartX, toLineY, toLineEndX, toLineY);

        const author7X = toX;
        const author7Y = 310;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(`${this.nameOfClient}`, author7X, author7Y);

        const author10X = toX;
        const author10Y = 330;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.phoneOfClient) {
          doc.text(`${this.phoneOfClient}`, author10X, author10Y);
        }

        const author9X = toX;
        const author9Y = 350;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.emailOfClient) {
          doc.text(`${this.emailOfClient}`, author9X, author9Y);
        }

        const author8X = toX;
        const author8Y = 370;
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        if (this.addressOfClient?.city || this.addressOfClient?.street) {
          doc.text(
            `${this.addressOfClient.city || ''}${this.addressOfClient.street ? `, ${this.addressOfClient.street}` : ''}`,
            author8X,
            author8Y,
          );
        }
      };

      // Render the first page's static content and table
      renderStaticContent();
      renderTable(0);

      // Render subsequent pages with the table
      for (let i = 1; i < totalPages; i++) {
        doc.addPage(); // Add a new page for each set of rows
        renderTable(i);
      }

      // Add a line below the table
      const tableEndY = doc.lastAutoTable.finalY; // Get the y-coordinate where the table ends
      const lineStartTabX = 40; // Start x-coordinate of the line
      const lineEndTabX = doc.internal.pageSize.getWidth() - 40; // End x-coordinate of the line (full width with some margin)
      const lineTabY = tableEndY + 26; // Add spacing below the table

      doc.setFontSize(10);
      doc.setTextColor(255, 99, 99);
      doc.text('Vërejtje: Produktet mund të ndërrohen vetëm brenda 48h, pas pranimit të produktit.', 40, tableEndY + 15);


      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartTabX, lineTabY, lineEndTabX, lineTabY); // Use the correct variable

      const totalRemainingAmount = (this.totalPrice - this.paidAmount).toFixed(2);

      const totalPriceY = lineTabY + 15; // Add spacing below the line for TotalPrice
      const totalPaidY = totalPriceY + 25; // Add spacing below TotalPrice for TotalPaid


      // TotalPrice label
      const totalPriceLabelX = 600;
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(`${this.$t('TotalPrice')}`, totalPriceLabelX, totalPriceY, { align: 'right' });

      // TotalPrice value
      const totalPriceValueX = 670;
      doc.text(`${this.totalPrice}€`, totalPriceValueX, totalPriceY, { align: 'right' });

      // Add a line below the TotalPrice value
      const lineStartPriceX = totalPriceValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndPriceX = totalPriceValueX + 40; // End X-coordinate slightly right of the value
      const linePriceY = totalPriceY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartPriceX, linePriceY, lineEndPriceX, linePriceY);

      // TotalPaid label
      const totalPaidLabelX = 600;
      doc.setFontSize(10);
      doc.text(`${this.$t('TotalPaid')}`, totalPaidLabelX, totalPaidY, { align: 'right' });

      // TotalPaid value
      const totalPaidValueX = 670;
      doc.text(`${this.paidAmount}€`, totalPaidValueX, totalPaidY, { align: 'right' });

      // Add a line below the TotalPaid value
      const lineStartPaidX = totalPaidValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndPaidX = totalPaidValueX + 40; // End X-coordinate slightly right of the value
      const linePaidY = totalPaidY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartPaidX, linePaidY, lineEndPaidX, linePaidY);

      // RemainingAmount label
      const remainingAmountLabelX = 600;
      doc.setFontSize(10);
      const remainingAmountY = totalPaidY + 25; // Position RemainingAmount below TotalPaid
      doc.text(`${this.$t('RemainingAmount')}`, remainingAmountLabelX, remainingAmountY, { align: 'right' });

      // RemainingAmount value
      const remainingAmountValueX = 670;
      doc.text(`${totalRemainingAmount < 0 ? 0 : totalRemainingAmount}€`, remainingAmountValueX, remainingAmountY, { align: 'right' });

      // Add a line below the RemainingAmount value
      const lineStartRemX = remainingAmountValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndRemX = remainingAmountValueX + 40; // End X-coordinate slightly right of the value
      const lineRemY = remainingAmountY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartRemX, lineRemY, lineEndRemX, lineRemY);

      const taxRateLabelX = 600;
      doc.setFontSize(10);
      const taxRateY = remainingAmountY + 25; // Position TaxRate below RemainingAmount
      doc.text(`${this.$t('TVSH')}-${this.selectedVAT}%`, taxRateLabelX, taxRateY, { align: 'right' });

      // TaxRate value
      const taxRateValueX = 670;
      doc.text(`${this.taxPrice}€`, taxRateValueX, taxRateY, { align: 'right' });

      // Add a line below the TaxRate value
      const lineStartTaxX = taxRateValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndTaxX = taxRateValueX + 40; // End X-coordinate slightly right of the value
      const lineTaxY = taxRateY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartTaxX, lineTaxY, lineEndTaxX, lineTaxY);

      const shipmentPriceLabelX = 600;
      doc.setFontSize(10);
      const shipmentPriceY = taxRateY + 25; // Position ShipmentPrice below TaxRate
      doc.text(`${this.$t('Discount')}`, shipmentPriceLabelX, shipmentPriceY, { align: 'right' });

      const formattedShipmentPrice = this.shipmentPrice ?? 0;

      // ShipmentPrice value
      const shipmentPriceValueX = 670;
      doc.text(`${formattedShipmentPrice}€`, shipmentPriceValueX, shipmentPriceY, { align: 'right' });

      // Add a line below the ShipmentPrice value
      const lineStartShipX = shipmentPriceValueX - 62; // Start X-coordinate slightly left of the value
      const lineEndShipX = shipmentPriceValueX + 40; // End X-coordinate slightly right of the value
      const lineShipY = shipmentPriceY + 4; // Line Y-coordinate, slightly below the value
      doc.setDrawColor(192, 192, 192); // Gray color for the line
      doc.setLineWidth(0.2); // Line thickness
      doc.line(lineStartShipX, lineShipY, lineEndShipX, lineShipY);

      const addressX1 = 40;
      const addressY1 = lineTabY + 5;
      const rectWidth = 450; // Maximum width for the rectangle
      const rectHeight = 90; // Fixed height for the rectangle

      // Set font size
      doc.setFontSize(10);

      // Set background color for the rectangle (light red)
      doc.setFillColor(173, 173, 173); // RGB for light red
      doc.rect(addressX1, addressY1, rectWidth, rectHeight, 'F'); // Draw the fixed-height rectangle

      // Set text color inside the rectangle (white)

      // Concatenate the label and remark text
      doc.setTextColor(0, 0, 0);
      const labelAndRemark = `${this.$t('InvoiceRemark')}: ${this.remark}`;

      // Calculate the maximum width for the text inside the rectangle
      const textWidth = rectWidth - 10; // Max width with padding

      // Add the concatenated label + remark text inside the rectangle
      doc.text(labelAndRemark, addressX1 + 5, addressY1 + 15, { maxWidth: textWidth, align: 'left' });

      return doc;
    },
    onCancel() {
      this.$emit('closeSidebar')
      this.resetForm()
    },
    resetForm() {
      this.pdfText = 'Invoice'
      this.createHouseItemRequestDtos = [];
      this.articleList = [];
      this.isButtonSubmited = false;
      this.clientData = null;
      this.clientError = false;
      this.filiale = { storeId: null, storeName: 'No filiale', storeGLN: null };
      this.totalCost = 0;
      this.createFileDataDto = [];
      this.shippings = {
        cost: null,
        accountId: null,
        currency: '€',
        notes: '',
        paidAmount: null,
      };
      this.description = '';
      this.roleId = null;
      this.invoiceRemark = null;
      this.sellDate = moment().format('YYYY-MM-DD');
      this.pickUpDate = null;
      this.transport = true;
      this.montage = true;
      this.montageStart = null;
      this.montageEnd = null;
      this.durationTimeMinutes = 0;
      this.durationTimeHour = 0;
      this.accountId = null;
      this.priceWithoutVAT = 0;
      this.selectedVAT = 18;
      this.totalCostOfAll = 0;
      this.currency = '€';
      this.discountType = '€';
      this.discount = 0;
      this.paidPrice = 0;
      this.plusTotal = 0;
      this.remainingPriceTotal = 0;
      this.resetFirstNames();
      this.resetClientId()
      this.$refs.modal.hide();
    },
  },
}
</script>

  <style lang="scss" scoped>
    form {
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .deactivate-modal__select {
      display: flex;
      flex-direction: column;
      select {
        margin-bottom: 10px;
        padding: 10px;
      }
      button {
        align-self: end;
      }
    }
    .flex-form {
      display: flex;
      flex-direction: column;
    }
    .my-class {
    background: black;
    font-weight: bold;
  }

  </style>
